import PropTypes from 'prop-types';
import React from 'react';

import Formaters from '../../formatters';

function Decimal({ value, locales }) {
    const formatter = Formaters.getDecimalFormatter(locales);
    return (
        <span className="format-decimal" data-value={value}>
            {formatter.format(value)}
        </span>
    );
}

Decimal.propTypes = {
    value: PropTypes.number.isRequired,
    locales: PropTypes.string,
};
Decimal.defaultProps = {
    locales: 'en-us',
};

export default Decimal;
